import PortfolioDetails from "./PortfolioDetails";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useRef } from "react";
import { Box, Typography, Container, Button } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useTheme } from "../../contexts/ThemeContext";

const Portfolio = () => {
  const { fundName, strategyName } = useParams();
  const { currentTheme } = useTheme();
  const exportRef = useRef(null);

  return (
    <>
      <Helmet>
        <title>Portfolio | Vantage Alpha</title>
      </Helmet>

      <Box
        sx={{
          backgroundColor:
            currentTheme.palette.mode === "light"
              ? "#ebebeb"
              : currentTheme.palette.grey[50],
          background:
            currentTheme.palette.mode === "light"
              ? "#ebebeb"
              : currentTheme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              mb: 3,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  color: currentTheme.palette.text.primary,
                  mb: 1,
                }}
              >
                Portfolio
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: currentTheme.palette.text.secondary,
                }}
              >
                Monitor portfolio performance, positions, and market data
              </Typography>
            </Box>
            <Button
              size="medium"
              onClick={() => exportRef.current?.()}
              aria-label="Export portfolio"
              startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: 24 }} />}
              sx={{
                flexShrink: 0,
                mt: 2,
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 500,
              }}
            >
              Export
            </Button>
          </Box>
          <PortfolioDetails
            fundName={fundName}
            strategyName={strategyName}
            exportRef={exportRef}
          />
        </Container>
      </Box>
    </>
  );
};
export default Portfolio;
